import Immutable from 'seamless-immutable';

import * as types from './types.js';

const initialState = Immutable({
    loading: false,
    failed: false,
    solution: null
});

export const solutionsReducer = (state = initialState, action) => {
    switch (action.type) {
        //#region GET_SOLUTION
        case types.GET_SOLUTION_REQUEST: {
            return state.merge({
                loading: true,
            });
        }
        case types.GET_SOLUTION_SUCCESS: {
            return state.merge({
                loading: false,
                solution: action.payload
            });
        }
        case types.GET_SOLUTION_FAILURE: {
            return state.merge({
                loading: false,
                failed: true
            });
        }
        //#endregion
        default: {
            return state;
        }
    }
}